import { useAppDispatch } from "app/hooks";
import { RootState } from "app/store";
import { setOpenPanel } from "features/settings/details-slice";

/**
 * # Field Report OnClick
 * Method 1: Open in Right Panel
 * @note This method would be "better" if using the PDF and not the dynamically
 * generated report
 */
export const fieldReportInRightPanel =
  (dispatch: ReturnType<typeof useAppDispatch>) => () => {
    dispatch(setOpenPanel("reportView"));
  };

/**
 * # Field Report OnClick
 * Method 2: Open in new tab - preferred by client
 */
export const fieldReportNewWindow =
  (
    currentFieldDetails: RootState["panorama"]["currentFieldDetails"],
    guid: RootState["panorama"]["guid"]
  ) =>
  () => {
    // Method 1: Open in Right Panel
    // NOTE: This method would be bettwe if using the PDF and not the
    // dynamically generated report
    // dispatch(setOpenPanel("reportView"));
    // Method 2: Open in new tab - preferred by client
    if (currentFieldDetails && currentFieldDetails.field_report_url && guid) {
      window.open(
        currentFieldDetails.field_report_url.replace("[GUID]", guid),
        "_blank"
      );
    } else {
      // TODO: Handle error message
      // NOTE: This would be a fallback but should never call because the
      // button should be disabled before this is called
      // IDEA: `toast.error`
    }
  };

/**
 * # Sphere Date OnClick
 *
 */
export const sphereDateOnClick =
  (dispatch: ReturnType<typeof useAppDispatch>) => () => {
    dispatch(setOpenPanel("sphereSelector"));
  };

/**
 * # Scout Date OnClick
 *
 */
export const scoutDateOnClick =
  (dispatch: ReturnType<typeof useAppDispatch>) => () => {
    dispatch(setOpenPanel("sphereSelector"));
  };

/**
 * # Field Selector OnClick
 *
 */
export const selectFieldOnClick =
  (dispatch: ReturnType<typeof useAppDispatch>) => () => {
    dispatch(setOpenPanel("fieldSelector"));
  };
